import { NumberFormat } from '@billy/design-system'

import { TaxRate } from '@modules-deprecated/app/taxrates/types'

import { LocaleIdentifier } from '../../../../types/localeIdentifier'

interface GetDisplayTitleOptions {
  isFullTitle?: boolean
  isShortTitle?: boolean
  locale: LocaleIdentifier
  taxRate: TaxRate
}

export const getDisplayTitle = ({ isShortTitle, isFullTitle, locale, taxRate }: GetDisplayTitleOptions): string => {
  const taxRateName = taxRate.name
  const taxRatePercent = NumberFormat.getPercentNumber(taxRate.rate, locale)

  if (isShortTitle) {
    return taxRatePercent
  }

  if (isFullTitle) {
    return `${taxRatePercent} (${taxRateName})`
  }

  return taxRateName
}
